import { IResponse } from '../../common/model/Core.model'
import {environment} from '../../util/Environment'
import {apiSlice} from '../store/Api'
import { IUserCreateRequestDto, IUserDto, IUserSearchRequestDto, IUserUpdateRequestDto } from './User.model'

export const userApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      userSearch: builder.mutation<IResponse, IUserSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.user}/search`,
            method: 'POST',
            body,
          }
        },
      }),
      userLoadMore: builder.mutation<IResponse, IUserSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.user}/search`,
            method: 'POST',
            body,
          }
        },
      }),
      userCreate: builder.mutation<IUserDto, IUserCreateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.user}`,
            method: 'POST',
            body,
          }
        },
      }),
      userGetById: builder.mutation<IUserDto, {id: string; fields?: string}>({
        query(parameters) {
          const queryParams = parameters.fields ? `?fields=${parameters.fields}` : ''
          return {
            url: `${environment.apiUrl.user}/${parameters.id}` + queryParams,
            method: 'GET',
          }
        },
      }),
      userUpdateById: builder.mutation<IUserDto, IUserUpdateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.user}/${body.id}`,
            method: 'PATCH',
            body,
          }
        },
      }),
      userDeleteById: builder.mutation<IUserDto, string>({
        query(id) {
          return {
            url: `${environment.apiUrl.user}/${id}`,
            method: 'DELETE',
          }
        },
      }),
    }
  },
})

export const {
  useUserSearchMutation,
  useUserLoadMoreMutation,
  useUserCreateMutation,
  useUserGetByIdMutation,
  useUserUpdateByIdMutation,
  useUserDeleteByIdMutation,
} = userApi
